export default "__VITE_ASSET__RotRz2Jl__"